import i18n from "src/i18n/config";
import { z } from "zod";

import { SimplePolicyRule } from "../types";
import { toBoolean } from "../utils";

const kioskEnabledPreference = {
    command: "changePreference",
    package: "com.emteria.kiosk",
    category: "com.emteria.kiosk_preferences",
    key: "prefs_kiosk_enabled_key",
    type: "bool",
};
const kioskModeSchema = z.object({ enabled: z.boolean() });

export const kioskMode: SimplePolicyRule<z.infer<typeof kioskModeSchema>> = {
    id: "kioskMode",
    title: () => i18n.t("modals:addRule.rules.kioskMode.title"),
    description: () => i18n.t("modals:addRule.rules.kioskMode.description"),
    details: () => i18n.t("modals:addRule.rules.kioskMode.details"),
    summary: (_, { enabled }) =>
        enabled
            ? i18n.t("modals:addRule.rules.kioskMode.summaryEnabled")
            : i18n.t("modals:addRule.rules.kioskMode.summaryDisabled"),
    categories: ["kiosk"],
    fields: [{ type: "boolean", name: "enabled", label: () => i18n.t("common:label.enabled") }],
    defaultValues: { enabled: true },
    schema: kioskModeSchema,
    command: kioskEnabledPreference,
    toValues: ({ enabled }) => String(enabled),
    fromValues: (enabled) => ({ enabled: toBoolean(enabled) }),
    flags: [],
};
